import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {EventsService} from '../../../services/events.service';
import {Action, Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as actions from '../../../store/actions';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {EventNumber_Str} from '../../../shareModel';



@Injectable()
export class EventMapEffects {
  private actions$ = inject(Actions);
  private eventService = inject(EventsService);
  private store$ = inject(Store<fromStore.State>);

  private injector = inject(Injector);



  constructor() {}
  getEventMapsEffect$ = createEffect(() => this.actions$.pipe(
      ofType(actions.EventMapActionTypes.GetEventMaps),
      withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
      switchMap(([action, currentUser]) => {
        if (currentUser) {
          return this.eventService.getEventMaps(currentUser.otp).pipe(
            map((res: any) => {
              if (res.result && Array.isArray(res.msg.data)) {
                const translatedData = res.msg.data.map((item) => ({
                  ...item,
                  desc: this.injector.get(TranslateService).instant(EventNumber_Str + item.num.toString(), {Default: item.desc})
                }));
                return new actions.LoadEventMaps(translatedData);
              }
            })
          );
        }
      })
    ));
  changeLanguageEventMaps$ = createEffect(() => this.actions$.pipe(
      ofType(actions.EventMapActionTypes.ChangeLanguageEventMaps),
      withLatestFrom(this.store$.select(fromStore.getEventsMapsState)),
      switchMap(([action, data]) => {
        if (Object.keys(data.entities).length > 0) {
          const res = Object.values(data.entities).map((item: any) => ({
            ...item,
            desc: this.injector.get(TranslateService).instant(EventNumber_Str + item.num.toString(), {Default: item.desc})
          }));
          return of(new actions.LoadEventMaps(res));
        } else {
          return of(new actions.GetEventMapsFail());
        }
      })
    ));

}
